import type {
  IF360Currency,
  TCurrencyValue
} from "@/core/plugins/currency.js/types";
import { IGetResponseBase } from "@/features/financas/views/Indicadores/services/types";
import { IShortcut } from "../Shortcuts/Shortcut";
import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";

@injectable()
export default class AmountFormat {
  @inject(DITypes.CURRENCY)
  currency!: IF360Currency;

  getShortnameMoney(value: TCurrencyValue) {
    if (typeof value === "number") {
      value = this.currency.toMoney(value);
    }

    const shortName = new Map([
      [2, "Mil"],
      [3, "Mi"],
      [4, "Bi"]
    ]);

    const amountArray = value.split(".")[0];
    const amountLength = value.split(".").length;
    const islowAmount = amountLength === 1;

    const amountFormat = islowAmount
      ? value
      : `${amountArray} ${shortName.get(amountLength)}`;

    return amountFormat;
  }

  //@kleber
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reduceTotalValue(array: Record<string, any>[], keyReference: string) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return array.reduce((acc: number, value: Record<string, any>) => {
      acc = acc += value[keyReference];

      return acc;
    }, 0);
  }

  fillEmptyDates(days: IGetResponseBase[], params: IShortcut) {
    const rangeDateArray = [];

    const initial = new Date(params.initialDate || "");
    let counter = 0;

    while (new Date(initial) < new Date(params.finalDate || "")) {
      const dayRange = new Date(initial.setDate(initial.getDate() + counter));
      if (!counter) counter = 1;

      const addZero = (value: number) => {
        const toStringNumber = String(value);

        return toStringNumber.length === 1 ? `0${value}` : value;
      };

      const formatedDate = `${dayRange.getFullYear()}-${addZero(
        dayRange.getMonth() + 1
      )}-${addZero(dayRange.getDate())}`;
      rangeDateArray.push(formatedDate);
    }

    const allDates = rangeDateArray.map((day) => {
      const hasDay = days.find((date) => date.saleDate === day);

      return hasDay || { saleDate: day, totalValue: 0 };
    });

    return allDates;
  }

  spliceIntoChunks(array: unknown[], chunkSize: number) {
    const splitedArray = [];
    while (array.length > 0) {
      const chunk = array.splice(0, chunkSize);
      splitedArray.push(chunk);
    }

    return splitedArray;
  }
}
